export const environment = {
  production: false,
  name: 'development',
  apiUrl: 'https://erpback.nucleo.dev/api',
  url_keycloak: 'http://localhost:8180',
  geoserver_url: 'http://localhost:8600/geoserver',
  geoserver_key: '',
};

